import makeStyles from "@mui/styles/makeStyles";
import { FormControl, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import { getBrandCustom } from "Util/getCustomColor";
import { colors } from "@zapalacorp/tokens";

export const WrapperInfo = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  cursor: "help",
  "& > svg": {
    color: colors.gray500,
    fontSize: 14,
    fontWeight: 600,
  },
}));

export const FormControlCustomized = styled(FormControl)<{
  bordercolor?: string;
  disabled?: boolean;
}>((props) => ({
  display: "flex",
  justifyContent: "flex-end",
  width: "100%",
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: !props?.disabled ? props?.bordercolor : "#C4C4C4",
  },
  "&:active .MuiOutlinedInput-notchedOutline": {
    borderColor: !props?.disabled ? props?.bordercolor : "#C4C4C4",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: !props?.disabled ? props?.bordercolor : "#C4C4C4",
  },
}));

export const PaperCustomized = styled(Paper)<{ freeSolo?: boolean }>(({ freeSolo }) => ({
  borderRadius: "8px",
  fontFamily: "Manrope",
  fontWeight: 500,
  color: "#667085",
  boxShadow: freeSolo ? "none" : "12px",
  "& .MuiAutocomplete-listbox": {
    "& li": {
      paddingTop: "8px",
      paddingBottom: "8px",
    },
    "& :hover": {
      backgroundColor: "#EDF5FB",
      color: colors.brandBlue600,
    },
  },
  "& .MuiListSubheader-root": {
    color: "#475467",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.5px",
  },
}));

const styles = makeStyles(() => ({
  iconError: {
    marginRight: "5px",
    fontSize: "16px",
  },
  circularProgress: {
    color: getBrandCustom("primaryColor", colors.brandBlue600),
  },
  formHelper: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "14px",
    lineHeight: "24px",
    color: "#D92D20",
    alignItems: "center",
    display: "flex",
    margin: 0,
  },
  label: {
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "24px",
    color: (props: { disabled?: boolean }) =>
      props?.disabled ? "#667085" : getBrandCustom("darkPrimaryColor", colors.brandBlue600),
    gap: "4px",
    display: "flex",
    marginBottom: "4px",
  },
  required: {
    color: (props: { disabled?: boolean }) => (props?.disabled ? "#667085" : "#F04438"),
  },
  addButton: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    boxShadow: "0px -1px 4px rgba(147, 169, 189, 0.18)",
    paddingLeft: "5px",
    "& svg": {
      height: "15px",
      width: "15px",
    },
  },
  extraSmallIcon: {
    fontSize: "14px",
  },
}));

export default styles;
